import CModal from './modals'
import CForms from './forms'

export default {
    install(app) {
        app.use(CModal)
        app.use(CForms)
    }
}
